angular.module('jv.submitToHM.controller', [])
    .controller('jvSubmitToHMController', [
        '$scope', '$rootScope','TemplateLoader','jvCandidatesService','$timeout','$window','jvHireBroadcastSVC','jvHireUrlService',
        function($scope, $rootScope,TemplateLoader,jvCandidatesService,$timeout,$window,jvHireBroadcastSVC,jvHireUrlService) {

            var refreshGrid = function(){
                var CandidateListUrl = jvHireUrlService.getCandidateListPageUrl();
                $timeout(function(){
                    $window.location.href = CandidateListUrl;
                },1500);
            };
            //notifications after submit to HM
            var showNotification =  function(value,isRestrictedState) {
                if(value === 1){
                    if(JV.Person && $scope.CandidateListPage){
                        JV.Person.Global.grid.removeLoadingState();
                        JV.Person.Const['SUBMIT_HM_SINGLE'] = value+' '+JV.Person.Const['SUBMIT_HM_SINGLE'];
                        JV.Util.showMessage(JV.Person.Const['SUBMIT_HM_SINGLE']);
                        refreshGrid();
                    }else{
                        $scope.showMsg('CANDIDATE_SUBMITTED');
                        if(isRestrictedState){
                            $scope.flags.loading = false;
                            $rootScope.$broadcast('showRestrictedCandidateModal');
                        }
                        else{
                            if($scope.activeTab('notes')) {
                                $scope.flags.add = true;
                                $scope.getNotes(0, 1, null, 0);
                            }
                                if($scope.getNotesCount){
                                    $scope.getNotesCount(true);
                                }
                                if($scope.updateWorkflowActions){
                                    $scope.updateWorkflowActions();
                                }
                                $scope.flags.loading = false;
                                $rootScope.$broadcast('showChangeStatusResult',true);
                            }
                    }
                }else{
                    if(JV.Person && JV.Person.Global){
                        JV.Person.Global.grid.removeLoadingState();
                        JV.Person.Const['SUBMIT_HM_MULTIPLE'] = value+' '+JV.Person.Const['SUBMIT_HM_MULTIPLE'];
                        JV.Util.showMessage(JV.Person.Const['SUBMIT_HM_MULTIPLE']);
                        refreshGrid();
                    }
                    $rootScope.$broadcast('showChangeStatusResult',true);
                }
            };

            jvHireBroadcastSVC.subscribe('showsubmitToHMModal', function(event, data) {
                //New stuff added for bulk submit to hiring manager use case.
                $scope.applicationIds = data.appIds;
                $scope.candidateName = data.name;
                //Used to track if the user is on the candidate list page or details page
                $scope.CandidateListPage = false;
                $scope.CandidateDetailsPage = false;
                $scope.stateId = data.stateId;
                $scope.jobEId = data.jobEId;
                if(data.appIds.length===1 && data.stateId){
                    //Candidate details page
                    $scope.CandidateListPage = false;
                    $scope.CandidateDetailsPage = true;
                    $scope.applicationId = data.appIds[0];
                }else{
                    //Candidate list page
                    $scope.CandidateListPage = true;
                    $scope.CandidateDetailsPage = false;
                }
                if(!$scope.appDetails){
                    $scope.CandidateListPage = true;
                    $scope.CandidateDetailsPage = false;
                }
                $scope.checkHM();
            });
            var i18n;
            if($.isEmptyObject($scope.i18n)){
                //Candidate list page does not have i18n
                i18n = {
                    TO: 'To',
                    TEMPLATE: 'Template',
                    COMPANY: 'Company',
                    CANCEL: 'Cancel',
                    SUBJECT: 'Subject',
                    MESSAGE: 'Message',
                    UPLOAD_A_FILE: 'Upload File',
                    DROP_FILE:'Or drop files here from your desktop to upload',
                    SUBMIT:'Submit'
                };
            }else{
                i18n = angular.copy($scope.i18n);
            }

            // Modal Information
            $scope.modals = {
                submitToHM: {
                    show: false
                },
                noHiringManager: {
                    show: false
                }
            };

            var getmodalConfig = function(action){
                //$scope.select2Options is defined $rootScope as part jv module in jv.js
                $scope.templateData = $scope.select2Options.setTemplates($scope.templateData);
                switch (action) {
                        case 'submitToHM':
                    //send Message modal config
                    $scope.submitToHMModalConfig = {
                        resetModalOn:'modals.submitToHM.show',
                        to: {
                            label:i18n['TO'],
                            type: 'dropDown',
                            required: true,
                            errorText: i18n['JV_SUBMITTOHM_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                            data: $scope.toList
                        },
                        templates: {
                            type: 'dropDown',
                            data: $scope.templateData,
                            label:i18n['TEMPLATE'],
                            post:{
                                callBack: $scope.submitToHM,
                                button: {
                                    label: i18n['SUBMIT'],
                                    type: 'button',
                                    classNames:['blue-btn','float-right'],
                                    id:'submit-hm-btn'
                                }
                            }
                        },
                        fileUploader: true,
                        customHtml: [{
                            label: i18n['JV_SUBMITTOHM_CONTROLLER_CANDIDATE_RESUME_WILL_BE_INCLUDED_WITH_THE_EMAIL_I'],
                            data: {
                                    type: 'paragraph',
                                    key:'submitHMCheck'
                            }
                        }],
                        subject: {
                            required: true,
                            errorText: i18n['JV_SUBMITTOHM_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                            label:i18n['SUBJECT']
                        },
                        message: {
                            required: true,
                            errorText: i18n['JV_SUBMITTOHM_CONTROLLER_THIS_IS_A_REQUIRED_FIELD'],
                            label:i18n['MESSAGE']
                        }

            };//end config object
            return $scope.submitToHMModalConfig;
        }
    };

        //Function to set up form template config. Making sure this is fired after we get workflowEId back from get appdetails call
        var setupFormTemplateConfig = function(action){
            //FormTemplateConfig
            $scope.formTemplateConfig = getmodalConfig(action);
        };

        //Used to show the move modal
        $scope.showModals = function(modal,skipConfigSetup){
            if(!skipConfigSetup){
                setupFormTemplateConfig(modal);
            }
            TemplateLoader.load(modal).then(function(){
                    $scope.modals[modal].show = true;
            });
        };

        $scope.templates = TemplateLoader.register({
            submitToHM: '/jhire/modules/candidates/modals/submitToHiringManager.html',
            noHiringManager: '/jhire/modules/candidates/modals/noHiringManager.html'
        });
        //Used to hide all the modals on the page
        $scope.hideModals = function(){
            angular.forEach($scope.modals, function(val, key) {
                 $scope.modals[key].show = false;
            });
            if(JV.Person && $scope.CandidateListPage){
                JV.Person.resetValues();
            }
        };

        //Used to check if the job has a hiring manager associated if not we show a modal where user can add a hiring manager
        $scope.checkHM = function(){
            var data = {};
            if($scope.CandidateListPage){
                data.jobId = $scope.jobEId;
                data.bulk = true;
                data.applicationEIds = {
                    applicationEIds: $scope.applicationIds
                };
            }else{
                data.applicationId = $scope.applicationId;
                data.stateId = $scope.stateId;
            }
            $scope.flags.loading = true;
            //We need to fetch the submitHM template inorder to figure out if there is a HM for this job
            jvCandidatesService.getSubmitToHMTemplateForCandidate(data,function(response){
                if(response && response.status === 200){
                    //success
                    $scope.flags.loading = false;
                    if($scope.CandidateDetailsPage){
                        response.data = response.data.submitToHM.model;
                    }
                    $scope.templateData = response.data.templates;
                    $scope.toList = response.data.users;
                    $scope.primaryHM = response.data.primaryHMEId;
                    if(response.data && !response.data.users.length){
                        $scope.isGeneralApplication = response.data.isGeneralApplication;
                        $scope.showModals('noHiringManager',true);
                    }else{
                        $scope.showModals('submitToHM');
                    }
                }else{
                    //fail
                    $scope.flags.loading = false;
                }
            });
        };

        var removeLoadingState = function(){
                if(JV.Person && $scope.CandidateListPage){
                    JV.Person.Global.grid.removeLoadingState();
                }else{
                   $scope.flags.loading = false;
                }
        };
        //Submit to HM POST
        $scope.submitToHM = function(modalData,noHiringManager) {
            var data = {};
            if(noHiringManager){
                data = {
                    toList: [],
                    content: '',
                    subject: '',
                    attachmentList: attachmentList

                };
            }else{
                if (!modalData.msgDataItem.to) {
                    return;
                }
                //Recipient
                var recipient = modalData.msgDataItem.to;
                //Attachment list
                var attachments = modalData.msgDataItem.attachments;
                var attachmentList = [];
                angular.forEach(attachments,function(attachment,key){
                    attachmentList.push(attachment.resourceInfo.eid);
                });
                //Msg Data Item
                data = {
                    toList: [recipient.EId],
                    content: modalData.msgDataItem.body,
                    subject: modalData.msgDataItem.subject,
                    attachmentList: attachmentList
                };
            }
            if($scope.CandidateListPage){
                data.entityIdList = $scope.applicationIds;
            }else{
                data.entityIdList = [$scope.applicationId];
            }
            $scope.flags.loading = true;
            if(JV.Person && $scope.CandidateListPage){
                JV.Person.Global.grid.showLoadingState();
            }
            /*BE expects locale to be sent to determine language for Email header/footer*/
            //Null check for {modalData}, as it will be null when There is no HM for Req
            if(modalData && modalData.msgDataItem && modalData.msgDataItem.template){
                data['locale'] = modalData.msgDataItem.template['locale'];
            }
            jvCandidatesService.submitCandidateToHM($scope.stateId, data, function(response) {
                if (response && response.status === 200) {
                    showNotification(response.data.count,response.data.isRestrictedWorkflowState);
                }else{
                    removeLoadingState();
                }
            });
            $scope.hideModals();
        };
    }
]);
